module.exports = __webpack_public_path__ + "assets/img/CurrencySurplus.83d4ec54.png";